import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-grid"
}
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_3 = { class: "u-mar-t-0" }
const _hoisted_4 = {
  key: 0,
  class: "c-form-control-checkbox form-group"
}
const _hoisted_5 = ["required", "aria-required"]
const _hoisted_6 = {
  class: "c-form-control-checkbox__label",
  for: "gewerbeZulaessigMakler"
}
const _hoisted_7 = { class: "c-form-control-checkbox__label-text" }
const _hoisted_8 = { class: "c-form-control-checkbox form-group" }
const _hoisted_9 = {
  class: "c-form-control-checkbox__label",
  for: "schlusserklaerungMakler"
}
const _hoisted_10 = { class: "c-form-control-checkbox form-group" }
const _hoisted_11 = { class: "o-grid__cell o-grid__cell--12-360 o-grid__cell--4-1024" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_Infotext = _resolveComponent("Infotext")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_abgesicherter_bereich = _resolveComponent("abgesicherter-bereich")!
  const _component_email_oder_herunterladen = _resolveComponent("email-oder-herunterladen")!

  return (_ctx.piniaStore.state.isMakler === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, " Folgende " + _toDisplayString(_ctx.piniaStore.state.isDunkelverarbeitung ? "Vertragsunterlagen" : "Antragsunterlagen") + " hat der Versicherungsnehmer erhalten: Das Informationsblatt zu Versicherungsprodukten, das Tarifinformationsblatt, die Kundeninformationen (einschließlich Belehrung über das Widerrufsrecht sowie die Hinweise zur vorvertraglichen Anzeigepflicht) die Versicherungsbedingungen, die Satzung und die Datenschutzhinweise zur Antrags- und Vertragsbearbeitung. ", 1),
          (_ctx.props.produkt === 'hg' && _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "c-form-control-checkbox__input",
                  id: "gewerbeZulaessigMakler",
                  name: "gewerbeZulaessigMakler",
                  required: _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden,
                  "aria-required": _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden,
                  "aria-describedby": "gewerbehilfe",
                  "data-fehlermeldung": "Bitte bestätigen Sie die Erklärung.",
                  "data-cy": "gewerbeZulaessigMaklerOption"
                }, null, 8, _hoisted_5),
                _createElementVNode("label", _hoisted_6, [
                  _createVNode(_component_icon_sprite, {
                    "icon-name": "icon-check-mark",
                    "css-klassen": "c-form-control-checkbox__icon",
                    "ist-klein": true
                  }),
                  _createElementVNode("span", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "gewerbe-zulaessig")
                  ])
                ]),
                _createElementVNode("span", {
                  class: "c-notice-icon",
                  "aria-hidden": "true",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.wechsleSichtbarkeit && _ctx.wechsleSichtbarkeit(...args)))
                }, [
                  _createVNode(_component_icon_sprite, { "icon-name": "icon-info-i" })
                ]),
                _createVNode(_component_Infotext, {
                  role: "tooltip",
                  id: "gewerbehilfe",
                  name: "gewerbeHilfe",
                  text: "Die GEV versichert keine Gebäude, in denen\n                  grundwassergefährdende Stoffe wie beispielsweise\n                  Farben, Lacke, Treibstoffe etc. über den\n                  haushaltsüblichen Umfang hinaus gelagert werden.\n                  Beispiele: Chemische Reinigungen, Tankstellen,\n                  Malereibetriebe, Lackierereien, Entsorgungs- und\n                  Recyclingbetriebe, Herstellerbetriebe von Farben und Lacken.<br /> <br />\n                  Die GEV versichert keine Gebäude in denen sich z. B.\n                  folgende Gewerbearten befinden: Stundenhotels,\n                  Bordelle, Discotheken, Nachtclubs und Bars."
                }),
                _createVNode(_component_validierungs_fehler, {
                  "fehler-text": _ctx.fehler.gewerbeZulaessigMakler
                }, null, 8, ["fehler-text"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("input", {
              type: "checkbox",
              class: "c-form-control-checkbox__input",
              id: "schlusserklaerungMakler",
              name: "schlusserklaerungMakler",
              required: "",
              "aria-required": "true",
              "data-fehlermeldung": "Bitte bestätigen Sie die Erklärung.",
              "data-cy": "schlusserklaerungMaklerOption"
            }, null, -1)),
            _createElementVNode("label", _hoisted_9, [
              _createVNode(_component_icon_sprite, {
                "icon-name": "icon-check-mark",
                "css-klassen": "c-form-control-checkbox__icon",
                "ist-klein": true
              }),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, " Der/die Versicherungsmakler/in bestätigt, dass er stellvertretend im Auftrage seines Mandanten die vorstehende Versicherung beantragt und dass ihm die vorbenannten Unterlagen und Informationen zur Verfügung stehen. ", -1))
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.schlusserklaerungMakler
            }, null, 8, ["fehler-text"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
            _renderSlot(_ctx.$slots, "schlusserklaerungMakler2"),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.schlusserklaerungMakler2
            }, null, 8, ["fehler-text"])
          ])
        ]),
        _createVNode(_component_email_oder_herunterladen, {
          produkt: _ctx.produkt,
          antrag: true,
          "tracking-zusatz": "abschluss"
        }, {
          "button-3": _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_abgesicherter_bereich, {
                "benoetigte-rollen": [
              'STANDARDNUTZER',
              'NUTZER',
              'GESCHAEFTSFUEHRER',
              'NUTZER_NEUGESCHAEFT',
              'GEV_MITARBEITER',
            ],
                "is-makler-link": _ctx.piniaStore.state.isMaklerLink
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    id: "btnAbsendenMakler",
                    class: "c-button c-button--full-width c-button--word-wrap-flex-height u-mar-b-6",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('antrag-absenden'))),
                    "data-cy": "btnAbsendenMakler"
                  }, _toDisplayString(_ctx.piniaStore.state.isDunkelverarbeitung
                  ? "Jetzt abschließen (beitragspflichtig)"
                  : "Jetzt verbindlich beantragen"), 1)
                ]),
                _: 1
              }, 8, ["is-makler-link"])
            ])
          ]),
          _: 1
        }, 8, ["produkt"])
      ]))
    : _createCommentVNode("", true)
}